import {
  getRequest,
  postRequest,
  // patchRequest,
  // deleteRequest,
} from '../../methods';

const getRecommendedActions = () => getRequest(`recommended_actions`);

const getRecommendedActionsSkip = recommendedActionId =>
  postRequest(`recommended_actions/${recommendedActionId}/skip`, {});

const recommendedActions = {
  getRecommendedActions,
  getRecommendedActionsSkip,
};

export default recommendedActions;
